document.addEventListener('click', function(e){
  const btn = e.target.closest('[data-action="save-discountcode"]');
  if (!btn) return;
  e.preventDefault();
  const input = document.getElementById('CartDiscountcode');
  if (!input){
    console.error('[Discount] input no encontrado');
    return;
  }
  const code = input.value.trim();
  if (!code){
    console.warn('[Discount] vacío');
    return;
  }
  const url = `/discount/${encodeURIComponent(code)}?redirect=/cart`;
  fetch(url, {
    method: 'GET',
    credentials: 'same-origin'
  })
  .then(res => {
    document.dispatchEvent(
      new CustomEvent('cart:refresh')
    );
  })
  .catch(err => {
    console.error('[Discount] error:', err);
  });
});